import { TreatmentDesignRevisionLiability } from './treatment-design-revision-judgement';
import { TreatmentTypeOriginalId } from './treatmentType';

export interface TreatmentDesignRevisionReason {
    id: number;
    liability: TreatmentDesignRevisionLiability;
    treatmentTypeOriginalId: TreatmentTypeOriginalId;
    content: string;
}

export interface InternalRevisionReasonDetail {
  id: number;
  treatmentId: string;     
  treatmentTypeOriginalId: number;
  liability: number;
  reasonDetail: string | '';
  createdBy: string;
  dateCreated: Date | string;  
  updatedBy: string | null;
  dateUpdated: Date | string | null;
}